module.exports = __webpack_public_path__ + "static/media/github-background.69b22ed9.svg";